module.exports = __webpack_public_path__ + "img/products12.0e0497bb.jpg";